var React = require('react');

function X (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"fill":"#E25886"},React.createElement("g",{"transform":"translate(-319 -27) translate(319 27)"},[React.createElement("rect",{"width":"12","height":"2","x":"-1","y":"4","rx":"1","transform":"rotate(45 5 5)","key":0}),React.createElement("rect",{"width":"12","height":"2","x":"-1","y":"4","rx":"1","transform":"rotate(-45 5 5)","key":1})]))));
}

X.defaultProps = {"width":"10","height":"10","viewBox":"0 0 10 10"};

module.exports = X;

X.default = X;
